export default __webpack_public_path__ + "static/media/Team1.cd93a100.jpg";